<template>
    <v-badge
        v-if="record.output"
        color="black"
        class="ml-2"
        :content="content"
        inline
    >
    </v-badge>
</template>
<script setup>
import { computed } from 'vue'
const props = defineProps({
    record: {
        type: Object,
        required: true,
    },
    count: {
        type: Number,
        default: 0,
    },
})
const content = computed(() => (props.count ? props.count : '0'))
</script>
